import styled, { css } from "styled-components";

const shimmer = css`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const grayShimmer = css`
  background: linear-gradient(
    90deg,
    #e0e0e0ff 25%,
    #d4d4d4ff 50%,
    #e0e0e0ff 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const purpleShimmer = css`
  background: linear-gradient(
    90deg,
    #5630beff 25%,
    #4e2ab1ff 50%,
    #5630beff 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const WalletSkeletonWhiteBox = styled.div<{
  width?: string;
  height?: string;
  radius?: string;
}>`
  ${shimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "14px"};
  border-radius: ${({ radius }) => radius || "4px"};
`;

export const WalletSkeletonGrayBox = styled.div`
  ${grayShimmer}
  width: 30px;
  height: 18px;
  border-radius: 4px;
`;

export const WalletSkeletonPurpleBox = styled.div<{
  width?: string;
  height?: string;
}>`
  ${purpleShimmer}
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "14px"};
  border-radius: 4px;
`;
